var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', [_c('div', [_c('h2', [_vm._v("Policy Rules")]), _c('div', {
    staticClass: "custom-search d-flex align-items-center justify-content-end"
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-sm-row align-items-center mb-1 justify-content-around"
  }, [_vm.$permissionAbility(_vm.RECURRING_PAYSLIP_POLICY_CREATE, _vm.permissions) ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0 mr-1",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v(" Create ")])] : _vm._e()], 2)]), _c('vue-good-table', {
    attrs: {
      "style-class": "vgt-table table-custom-style striped",
      "line-numbers": false,
      "mode": "remote",
      "total-rows": _vm.totalRecords,
      "is-loading": _vm.isLoading,
      "rows": _vm.rows,
      "sort-options": {
        enabled: false,
        multipleColumns: true,
        initialSortBy: [{
          field: 'id',
          type: 'desc'
        }, {
          field: 'created_at',
          type: 'desc'
        }]
      },
      "columns": _vm.columns,
      "pagination-options": {
        enabled: true,
        perPage: _vm.pageLength
      }
    },
    on: {
      "update:isLoading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "update:is-loading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        return [props.column.field === 'action' ? _c('span', [_c('span', [_c('b-dropdown', {
          attrs: {
            "variant": "link",
            "toggle-class": "text-decoration-none",
            "no-caret": ""
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function fn() {
              return [_c('feather-icon', {
                staticClass: "text-body align-middle mr-25",
                attrs: {
                  "icon": "MoreVerticalIcon",
                  "size": "16"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [_vm.$permissionAbility(_vm.RECURRING_PAYSLIP_POLICY_EDIT, _vm.permissions) ? [_c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.onShow(props.row);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "Edit2Icon"
          }
        }), _c('span', [_vm._v("Edit")])], 1)] : _vm._e(), _vm.$permissionAbility(_vm.RECURRING_PAYSLIP_POLICY_DELETE, _vm.permissions) ? [_c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.onDelete(props.row.id);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "TrashIcon"
          }
        }), _c('span', [_vm._v("Delete")])], 1)] : _vm._e()], 2)], 1)]) : _c('span', [_vm._v(" " + _vm._s(props.formattedRow[props.column.field]) + " ")])];
      }
    }, {
      key: "pagination-bottom",
      fn: function fn(props) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between flex-wrap"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-0 mt-1"
        }, [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Showing 1 to ")]), _c('b-form-select', {
          staticClass: "mx-1",
          attrs: {
            "options": ['10', '25', '50', '100', '500']
          },
          on: {
            "input": function input(value) {
              return props.perPageChanged({
                currentPerPage: value
              });
            }
          },
          model: {
            value: _vm.pageLength,
            callback: function callback($$v) {
              _vm.pageLength = $$v;
            },
            expression: "pageLength"
          }
        }), _c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" of " + _vm._s(props.total) + " entries ")])], 1), _c('div', [_c('b-pagination', {
          staticClass: "mt-1 mb-0",
          attrs: {
            "value": 1,
            "total-rows": props.total,
            "per-page": _vm.pageLength,
            "first-number": "",
            "last-number": "",
            "align": "right",
            "prev-class": "prev-item",
            "next-class": "next-item"
          },
          on: {
            "input": function input(value) {
              return props.pageChanged({
                currentPage: value
              });
            }
          },
          scopedSlots: _vm._u([{
            key: "prev-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronLeftIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }, {
            key: "next-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronRightIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }], null, true)
        })], 1)])];
      }
    }])
  })], 1), _c('b-modal', {
    attrs: {
      "id": "modal-recurring-policy-form",
      "centered": "",
      "title": _vm.modelType == 'editModel' ? 'Edit Policy Rule' : 'Create Policy Rule',
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.hiddenModal
    }
  }, [_c('validation-observer', {
    ref: "policyForm"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.submit($event);
      }
    }
  }, [_c('p', {
    staticClass: "d-flex flex-wrap align-items-center"
  }, [_vm._v(" In every "), _c('validation-provider', {
    attrs: {
      "name": "cycle",
      "vid": "cycle",
      "rules": "required|numeric|min:1|max:255"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('span', {
          staticClass: "d-inline-block mr-1",
          staticStyle: {
            "width": "100px"
          }
        }, [_c('b-form-input', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "type": "number",
            "state": errors.length ? false : null,
            "placeholder": "Cycle"
          },
          model: {
            value: _vm.cycle,
            callback: function callback($$v) {
              _vm.cycle = $$v;
            },
            expression: "cycle"
          }
        }), _c('div', {
          staticStyle: {
            "min-height": "1em"
          }
        }, [_c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])])], 1)];
      }
    }])
  }), _vm._v(" day"), _vm.cycle > 1 ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v(", you must complete at least "), _c('validation-provider', {
    attrs: {
      "name": "min hour",
      "vid": "min_hour",
      "rules": "required|numeric|min:1"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var errors = _ref2.errors;
        return [_c('span', {
          staticClass: "d-inline-block mr-1",
          staticStyle: {
            "width": "100px"
          }
        }, [_c('b-form-input', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "type": "number",
            "state": errors.length ? false : null,
            "placeholder": "Min Hour"
          },
          model: {
            value: _vm.min_hour,
            callback: function callback($$v) {
              _vm.min_hour = $$v;
            },
            expression: "min_hour"
          }
        }), _c('div', {
          staticStyle: {
            "min-height": "1em"
          }
        }, [_c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])])], 1)];
      }
    }])
  }), _vm._v(" hour"), _vm.min_hour > 1 ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v(" and at most "), _c('validation-provider', {
    attrs: {
      "name": "max hour",
      "vid": "max_hour",
      "rules": "required|numeric|min:1"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var errors = _ref3.errors;
        return [_c('span', {
          staticClass: "d-inline-block mr-1",
          staticStyle: {
            "width": "100px"
          }
        }, [_c('b-form-input', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "type": "number",
            "state": errors.length ? false : null,
            "placeholder": "Max Hour"
          },
          model: {
            value: _vm.max_hour,
            callback: function callback($$v) {
              _vm.max_hour = $$v;
            },
            expression: "max_hour"
          }
        }), _c('div', {
          staticStyle: {
            "min-height": "1em"
          }
        }, [_c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])])], 1)];
      }
    }])
  }), _vm._v(" hour"), _vm.max_hour > 1 ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v(". ")], 1), _vm.isLoading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])]], 2)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }